module.exports = __webpack_public_path__ + "img/tixing.da8cbfd2.png";